import { render, staticRenderFns } from "./ForkliftPermit.vue?vue&type=template&id=bad44e4c"
import script from "./ForkliftPermit.vue?vue&type=script&lang=js"
export * from "./ForkliftPermit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports